<div
  #modal
  class="modal"
  [class.is-active]="isActive"
  tabindex="0"
  [ngStyle]="{ 'z-index': zIndex }"
  (keydown.esc)="onPressEscKey()"
>
  <div class="modal-background"></div>
  <div
    class="modal-card"
    [class.small-width]="isSmall"
    [class.large-width]="isLarge"
    [class.full-width]="isFull"
  >
    <header class="modal-card-head has-background-white pb-0">
      <ng-content select="[modal-title]"></ng-content>
      <button
        type="button"
        *ngIf="showClose"
        class="delete"
        aria-label="close"
        (click)="modalInteration()"
        autofocus
      ></button>
    </header>
    <section class="modal-card-body" [class.foot]="!enableFooter" [class.is-paddingless]="!padding">
      <ng-content select="[modal-content]"></ng-content>
    </section>
    <section *ngIf="enableFooter">
      <footer class="pt-1 modal-card-foot has-background-white">
        <div class="footer-buttons">
          <div *ngIf="showAcceptFooter" class="mr-3">
            <app-input-submit
              inputText="{{ 'shared.acept' | translate }}"
              type="submit"
              [disabled]="acceptFooterDisabled"
              [isSuccess]="true"
              (clickButton)="sendAccept()"
            ></app-input-submit>
          </div>

          <div *ngIf="showCloseFooter">
            <app-input-submit
              inputText="{{ 'shared.close' | translate }}"
              type="submit"
              (clickButton)="modalInteration()"
            ></app-input-submit>
          </div>
        </div>
      </footer>
      <section *ngIf="!showCloseFooter" class="modal-card-body has-background-white foot">
        <ng-content class="" select="[modal-footer]"></ng-content>
      </section>
    </section>
  </div>
</div>
